import { numberPositive } from 'Data/validate.js'
import { FEE_MODE_RANGES } from 'Data/constants.js'

export function validateNumber(value) {
  return (
    numberPositive(value) &&
    value >= FEE_MODE_RANGES.PLATFORM_FEE.ACH.MIN &&
    value <= FEE_MODE_RANGES.PLATFORM_FEE.ACH.MAX
  )
}
